import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { batch } from 'react-redux'
import BetServices from '../services/BetServices';
import BetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import Constants from '../common/Constants';
import { openAlert, opentConfirmAlert } from './AlertSlice';
import BetslipCommon from '../common/BetslipCommon';
import { WinRiskType, BETSLIP_TABS, BUTTON_SELECTION, SPORT_TABS, MARKET_TABS, BetTypeGroup, Mode } from '../common/Foundation';
import {
  updateLoadingState,
  updateBetslipTabState,
  updateConfirmationRemoveState,
  reloadBalanceAndPendingBets,
  setIsInPlaceBetProcess,
  setIsReuseSelection,
} from './BetslipSlice';
import { changeButton, changeSportTab, changeMarketTab, changeSportId, changeMarketId } from './SidebarSelectedDataSlice';
import { triggerOddsPage, fetchSportsMenu } from './SidebarHandlerSlice';
import { updateIsSelectedHighlight, updateChangedOptions } from './SportsSlice';
import { EVENT } from '../events/listEvents';
import AccountAction from '../actions/AccountAction'
import { AccountsSlice } from './AccountsSlice';
import {GA4Common, GA_EVENT} from "../common/GA4Common";

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []
const EMPTY_VALUE = ''

const initialState = {
  teaserSelections: [],
  callbackSelection: {}, // empty current betslip and use it for new betslip

  teaserOddsPayload: {},

  teaserBets: {},
  teaserWin: '',
  teaserRisk: '',
  teaserBase: '',
  winRiskOption: WinRiskType.RISK,
  teaserAcceptBetterOdds: BetslipHelper.loadDefaultAcceptBetterOdds(),

  teaserBetSucessRes: {},
  isError: false,
  invalidStake: false
}

export const TeaserBetslipSlice = createSlice({
    name: 'TeaserBetslipSlice',
    initialState: initialState,
    reducers: {
      updateTeaserSelectionsState: (state, {payload}) => {
        state.teaserSelections = payload
      },
      updateTeaserOddsPayloadState: (state, {payload}) => {
        state.teaserOddsPayload = payload
      },
      updateTeaserBetsState: (state, {payload}) => {
        state.teaserBets = payload
      },
      updateTeaserStakeState: (state, {payload}) => {
        state.teaserStake = payload
      },
      updateTeaserWinState: (state, {payload}) => {
        state.teaserWin = payload === 0 ? EMPTY_VALUE : payload
      },
      updateTeaserRiskState: (state, {payload}) => {
        state.teaserRisk = payload === 0 ? EMPTY_VALUE : payload
      },
      updateTeaserBaseState: (state, {payload}) => {
        state.teaserBase = payload === 0 ? EMPTY_VALUE : payload
      },
      updateWinRiskOptionState: (state, {payload}) => {
        state.winRiskOption = payload
      },
      updateErrorState: (state, {payload}) => {
        state.isError = payload
      },
      updateTeaserBetSuccessResState: (state, {payload}) => {
        state.teaserBetSucessRes = payload
      },
      updateCallbackSelectionState: (state, {payload}) => {
        state.callbackSelection = payload
      },
      updateTeaserAcceptBetterOddsState: (state, {payload}) => {
        state.teaserAcceptBetterOdds = payload
      },
      removeAllTeaserBets: (state) => {
        state.teaserSelections = EMPTY_ARRAY
        state.teaserOddsPayload = EMPTY_OBJECT
        state.teaserBets = EMPTY_OBJECT
        state.teaserWin =  EMPTY_VALUE
        state.teaserRisk = EMPTY_VALUE
        state.teaserBase = EMPTY_VALUE
      },
      updateInvalidStake: (state, {payload}) => {
        state.invalidStake = payload
      },
    }
  });
  
  export const {
    updateTeaserSelectionsState,
    updateTeaserOddsPayloadState,
    updateTeaserBetsState,
    updateTeaserStakeState,
    updateTeaserWinState,
    updateTeaserBaseState,
    updateErrorState,
    updateTeaserRiskState,
    updateWinRiskOptionState,
    updateTeaserBetSuccessResState,
    removeAllTeaserBets,
    updateCallbackSelectionState,
    updateTeaserAcceptBetterOddsState,
    updateInvalidStake
  } = TeaserBetslipSlice.actions

  /** HANDLE BUSSINESS LOGIC */
  export const fetchTeaserOddsSelection = () => {
    return async (dispatch, getState) => {
      const { 
        teaserSelections,
        teaserBets
      } = getState().TeaserBetslipSlice

      if (teaserSelections.length === 0)  {
        return
      }
      const { oddsFormat }  = getState().SportsSlice.options
      const { teaserBetSucessRes } = getState().TeaserBetslipSlice

      const payload = BetslipHelper.buildTeaserBetTicketParams(teaserSelections, oddsFormat)
      dispatch(updateTeaserOddsPayloadState(payload))
      dispatch(updateLoadingState(true))
      try {
        const response =  await BetServices.getTeaserOddsSelection(payload).then(res => {
          return res.data
        }).catch(e => {
          dispatch(updateErrorState(true));
          const errResponse = e.response;
          if (errResponse && errResponse.status === 403) {
            AccountAction.clearCookie();
            dispatch(AccountsSlice.actions.resetUser());
            dispatch(openAlert(
              {
                message: "errors:MULTIPLE_LOGIN"
              }
            ))
            return
          }  
        });
        if (Object.keys(teaserBetSucessRes).length > 0) {
          dispatch(updateTeaserBetSuccessResState(EMPTY_OBJECT))
        }
        // response from teaser odds service is missing some information to display bet item, so we will get from teaser selection and merge into the response
        // const teaserBets = BetslipHelper.updateMoreInfoForTeaserOddsResponse(teaserSelections, payload, response)
        dispatch(updateLoadingState(false))
        let updatedTeaserBets = JSON.parse(JSON.stringify(response))
        let updatedTeaserSelections = JSON.parse(JSON.stringify(teaserSelections))
        BetslipHelper.updateMoreInfoForTeaserOddsResponse(updatedTeaserSelections, payload, updatedTeaserBets, teaserBets.minLegs)
        batch(() => {
          dispatch(updateTeaserSelectionsState(updatedTeaserSelections))
          dispatch(updateTeaserOddsPayloadState(payload))
          dispatch(updateTeaserBetsState(updatedTeaserBets))
        })
        
        window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET)
      } 
      catch (e) {
        dispatch(updateErrorState(true))
      }
    }
  }

  export const removeTeaserItem =  (legId) => {
    return async (dispatch, getState) => {
      const {
        teaserOddsPayload,
        teaserBets,
        teaserSelections
      } = getState().TeaserBetslipSlice

      if (teaserBets.legs && teaserBets.legs.length === 1) {
        dispatch(removeAllTeaserBets())
      } else {
        const { oddsFormat } = getState().SportsSlice.options
        const params = {
          ticketId: teaserBets.ticketId,
          teaserId: teaserBets.teaserId,
          oddsFormat: oddsFormat,
          legId: legId
        }
        dispatch(updateLoadingState(true))
        const response =  await BetServices.removeTeaserTicket(params).then(res => {
          return res.data;
        }).catch(e => {
    
        });
        dispatch(updateLoadingState(false))
        if (response) {
          if (response.legs.length < 1 && response.errorCode === Constants.TEASER_ERROR.SELECTION_UNAVALABLE) {
            dispatch(openAlert({
              message: 'errors:'+ response.errorCode
            }))
            return;
          } else {
            const payloadLegs = JSON.parse(teaserOddsPayload.legs)
            const legIdx = payloadLegs.findIndex(leg => {
              return leg.legId === legId
            })
            if (legIdx > -1) {
              const selection = teaserSelections.filter((sel, index) => {
                return sel.selectionId !== payloadLegs[legIdx].selectionId
              })
  
              const legs = payloadLegs.filter(leg => {
                return leg.legId !== legId
              })
  
              let updateTeaserOddsPayload =  JSON.parse(JSON.stringify(teaserOddsPayload))
              updateTeaserOddsPayload.legs = JSON.stringify(legs)
              BetslipHelper.updateMoreInfoForTeaserOddsResponse(selection, updateTeaserOddsPayload, response, teaserBets.minLegs)
              batch(() => {
                dispatch(updateTeaserSelectionsState(selection))
                dispatch(updateTeaserOddsPayloadState(updateTeaserOddsPayload))
                dispatch(updateTeaserBetsState(response))
              })
            }
          }
        }
      }
    }
  }

  export const executePlaceTeaserBet = () => {
    return async (dispatch, getState) => {
      const { oddsFormat } = getState().SportsSlice.options
      const {
        winRiskOption,
        teaserRisk,
        teaserWin,
        teaserBase,
        teaserBets,
        teaserOddsPayload,
        teaserSelections,
        teaserAcceptBetterOdds
      } = getState().TeaserBetslipSlice

      const {
        betCredit:currentBalance
      }=getState().AccountsSlice.user;
      let GAerrorMsg = "";

      const stakeInputs = {
        winRiskOption: winRiskOption,
        riskVal: teaserRisk,
        winVal: teaserWin,
        baseVal: teaserBase
      }

      const {
        ticketId,
        teaserId,
        legs
      } = teaserBets
      
      const payload = {
        teaserId: teaserId, 
        ticketId: ticketId, 
        oddsFormat: oddsFormat, 
        stake: BetslipHelper.getStake(stakeInputs),
        uniqueRequestId: BetslipCommon.generateUUID(), 
        winRiskStake: winRiskOption,
        acceptBetterOdds: teaserAcceptBetterOdds,
      }

      try {
        dispatch(updateLoadingState(true))
        dispatch(setIsInPlaceBetProcess(true));
        const res =  await BetServices.buyTeaserBetURL(payload, BetslipCommon.generateUUID()).then(res => {
          return res.data;
        }).catch(e => {
          dispatch(updateErrorState(true))
          dispatch(setIsInPlaceBetProcess(false));
        })
        dispatch(updateLoadingState(false))
        dispatch(setIsInPlaceBetProcess(false));
        const data = res.response;
        const errorCode = res.errorCode;
        if (errorCode) {
          let params =  []
          const errData = res.errorMessage
          if (errData) {
            params.push(errData)
          }
          dispatch(openAlert({
            message: 'errors:'+ errorCode,
            params: params
          }))
          GAerrorMsg = errorCode;
          return
        }
        const dataRes = data[0];
        const status = dataRes.status;
        switch (status) {
          case Constants.BET_STATUS.PROCESSED_WITH_ERROR:
            const invalidLegs = dataRes.invalidLegs;
            let error = 'Your bet has been rejected.';
            let changedLegs = [];
            let updatedTeaserBets = JSON.parse(JSON.stringify(teaserBets))
            if (invalidLegs) {
              let legError = '';
              invalidLegs.forEach((invalidleg, index) => {
                const legIdx = legs.findIndex(leg => {
                  return leg.legId === invalidleg.legId
                })
                if (legIdx > -1) {
                  const errorCode = invalidleg.errorCode;
                  if (errorCode === Constants.TEASER_ERROR.OFFLINE_EVENT || errorCode === Constants.TEASER_ERROR.INVALID_EVENT) {
                    legError = Constants.TEASER_ERROR.BET_OFFLINE_EVENT;
                    updatedTeaserBets.legs[legIdx].errorCode = legError
                  } else if (errorCode === Constants.TEASER_ERROR.LINE_CHANGED) {
                    legError = !legError ? Constants.TEASER_ERROR.BET_LINE_CHANGED : legError;
                    if (legError === Constants.TEASER_ERROR.BET_LINE_CHANGED) {
                      changedLegs.push(
                        {
                          "legId": invalidleg.legId,
                          "lineId": invalidleg.lineId,
                          "point": invalidleg.points,
                          "pointStatus": Constants.TEASER_ERROR.POINT_CHANGE
                        }
                      )
                      updatedTeaserBets.legs[legIdx].errorCode =  Constants.TEASER_ERROR.SELECTION_POINT_CHANGED
                    }
                  } else if (errorCode === Constants.TEASER_ERROR.LINE_IS_NOT_AVAILABLE) {
                    legError = !legError ? Constants.TEASER_ERROR.BET_LINE_IS_NOT_AVAILABLE : legError;
                    updatedTeaserBets.legs[legIdx].errorCode = legError
                  }
                }
              })
              error = legError;
            }
            if (changedLegs.length > 0) {
              let updatedOddsPayload = JSON.parse(JSON.stringify(teaserOddsPayload))
              let updatedTeaserSelections = JSON.parse(JSON.stringify(teaserSelections))
              const payloadLegs = JSON.parse(teaserOddsPayload.legs)
              // update new selection id
              changedLegs.forEach((changedLeg, index) => {
                const payloadIndex = payloadLegs.findIndex((payload, index) => {
                  return payload.legId === changedLeg.legId
                })
                if (payloadIndex > -1) {
                  const selectionIndex = teaserSelections.findIndex((selection, index) => {
                    return selection.selectionId === payloadLegs[payloadIndex].selectionId
                  })
                  if (selectionIndex > -1) {
                    const newSelectionId = changedLeg.lineId + '|' + teaserSelections[selectionIndex].oddsId + '|' + teaserSelections[selectionIndex].teamType + '|' + changedLeg.point
                    updatedTeaserSelections[selectionIndex].selectionId = newSelectionId
                    let legs = JSON.parse(updatedOddsPayload.legs)
                    legs[index].selectionId = newSelectionId
                    updatedOddsPayload.legs = JSON.stringify(legs)
                  }
                }
              })
              batch(() => {
                dispatch(updateTeaserOddsPayloadState(updatedOddsPayload))
                dispatch(updateTeaserSelectionsState(updatedTeaserSelections))
              })
            }
            dispatch(updateTeaserBetsState(updatedTeaserBets))

            dispatch(
              openAlert({
                message: 'errors:'+ error
              })
            )
            GAerrorMsg = error;
            break
          case Constants.BET_STATUS.PENDING_ACCEPTANCE:
          case Constants.BET_STATUS.ACCEPTED:
            const {
              betId,
              riskAmount,
              winAmount
            } = dataRes
            let acceptedTeaserBets = JSON.parse(JSON.stringify(teaserBets))
            acceptedTeaserBets.betId = betId
            acceptedTeaserBets.riskAmount = riskAmount
            acceptedTeaserBets.winAmount = winAmount
            GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode, currentBalance});
            batch(() => {
              dispatch(updateTeaserBetSuccessResState(acceptedTeaserBets))
              dispatch(removeAllTeaserBets())
              dispatch(setIsReuseSelection(false));
            })
            reloadBalanceAndPendingBets()
            break
          default:
        }
      } finally {
        GAerrorMsg && GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode: GAerrorMsg, currentBalance});
      }
    }
  }
  
  export const removeBetSuccessResponse = () => {
    return dispatch => {
      dispatch(updateTeaserBetSuccessResState(EMPTY_OBJECT))
    }
  }

  export const addTeaserSelection = (selection) => {
    return (dispatch, getState) => {
      const {
        teaserBets,
      } = getState().TeaserBetslipSlice
      let selections = JSON.parse(JSON.stringify(getState().TeaserBetslipSlice.teaserSelections))
      let isDisplayPopup = false, confirmMessage = '';
        if (selections.length === 0) {
          if (!selection && Object.keys(getState().TeaserBetslipSlice.callbackSelection).length > 0) {
            // renew teaser betslip after user confirm
            selection = JSON.parse(JSON.stringify(getState().TeaserBetslipSlice.callbackSelection))
            dispatch(updateCallbackSelectionState(EMPTY_OBJECT))
          }
          selections.push(selection)
        } else {
          if (selections.findIndex(sel => sel.sportId !== selection.sportId) > -1) {
            confirmMessage = Constants.TEASER_ERROR.SELECTING_PICK_DIFFERENT_SPORT
            isDisplayPopup = true
          } else if (selections.findIndex(sel => sel.teaserTypeId !== selection.teaserTypeId) > -1) {
            confirmMessage = Constants.TEASER_ERROR.SELECTING_PICK_DIFFERENT_TYPE
            isDisplayPopup = true
          } else if (selections.findIndex(sel => Number(sel.teaserPoint) !== Number(selection.teaserPoint)) > -1) {
            confirmMessage = Constants.TEASER_ERROR.SELECTING_PICK_DIFFERENT_POINT
            isDisplayPopup = true
          }else if (selections.findIndex(sel => sel.selectionId.split("|")[1] === selection.selectionId.split("|")[1] ) === -1 
            && teaserBets.isSameEvent) {
            confirmMessage = Constants.TEASER_ERROR.SAME_GAME_DIFFERENT_PICK
            isDisplayPopup = true
          }else if (teaserBets.maxLegs && selections.length >= teaserBets.maxLegs 
            && selections.findIndex(sel => sel.selectionId === selection.selectionId) === -1){
            dispatch(openAlert({
              message: 'errors:'+Constants.TEASER_ERROR.MAX_TEASERS
            }))
            return;
          }
          if (isDisplayPopup) {
            dispatch(updateCallbackSelectionState(selection))
            dispatch(opentConfirmAlert({
              title: 'Confirm bets',
              message: 'errors:'+confirmMessage,
              fireEventKey: EVENT.RENEW_TEASER_SELECTION
            }))
            return
          }
  
          const filter = selections.filter(sel => {
            return sel.selectionId === selection.selectionId
          })
          if (filter.length === 0) {
            selections.push(selection)
          } else {
            // re-select on teaser odds
            selections = selections.filter(sel => {
              return sel.selectionId !== selection.selectionId
            })
          }
      }
      batch(() => {
        dispatch(updateTeaserSelectionsState(selections))
        dispatch(fetchTeaserOddsSelection())
        dispatch(changeButton(BUTTON_SELECTION.BET_SLIP))
        dispatch(updateBetslipTabState(BETSLIP_TABS.TEASERS))
      })
    }
  }

  export const removeAll = () => {
    return (dispatch, getState) => {
      const { options } = getState().SportsSlice
      batch(() => {
        dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)));
        dispatch(removeAllTeaserBets())
        dispatch(updateConfirmationRemoveState(false))
      })
      
    }
  }

  export const openTeaserOddsPage = (sportId) => {
    return dispatch => {
      batch(() => {
        dispatch(updateChangedOptions({ 'mode': Mode.NORMAL }));
        dispatch(changeSportTab(SPORT_TABS.SPORTS))
        dispatch(changeMarketTab(MARKET_TABS.EARLY))
        dispatch(changeSportId(sportId))
        dispatch(changeMarketId([BetTypeGroup.TEASERS, 0].join('|')))
        dispatch(updateIsSelectedHighlight(false))
        dispatch(triggerOddsPage())
        dispatch(fetchSportsMenu())
      })
    }
  }
  export const checkInvalidStake = (stake) => {
    return (dispatch) => {
      let disable = !stake || stake == 0
      dispatch(updateInvalidStake(disable))
    }
  }

  /** END */
  export const teaserBetslipSelector = state => state.TeaserBetslipSlice
  export const getTeaserSelections = state => _.map(state.TeaserBetslipSlice.teaserSelections, selection => selection.selectionId);
  
  export default TeaserBetslipSlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/TeaserBetslipSlice.js